module.exports = __webpack_public_path__ + "static/media/eye.bf7e8f9c.svg";